import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=4ea1c05b"
import script from "./Target.vue?vue&type=script&lang=js"
export * from "./Target.vue?vue&type=script&lang=js"
import style0 from "./Target.vue?vue&type=style&index=0&id=4ea1c05b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports